import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://qm.fwcc.africa/api/v1',
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // For super admin, do NOT send organization header (backend allows unrestricted access)
  const userStr = localStorage.getItem('user');
  if (userStr) {
    try {
      const user = JSON.parse(userStr);
      if (user.role !== 'super_admin') {
        const orgId = localStorage.getItem('organizationId');
        if (orgId) {
          config.headers['X-Organization-ID'] = orgId;
        }
      }
    } catch (e) {
      // If parsing fails, fallback to sending header
      const orgId = localStorage.getItem('organizationId');
      if (orgId) {
        config.headers['X-Organization-ID'] = orgId;
      }
    }
  } else {
    // No user yet (maybe login request) – do not send header
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('organizationId');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;